import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectNotificationModel } from "../../models/ProjectNotificationModel";

type Props = {
  notifications: ProjectNotificationModel[];
};

const initialProjectNotificationState: Props = {
  notifications: [],
};

const ProjectNotificationSlice = createSlice({
  name: "ProjectNotification",
  initialState: initialProjectNotificationState,
  reducers: {
    setProjectNotifications(
      state,
      action: PayloadAction<ProjectNotificationModel[]>
    ) {
      state.notifications = action.payload;
    },
  },
});

export default ProjectNotificationSlice;
